import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml',
  standalone: false,
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';

    // 1. Remove all HTML tags
    let stripped = value.replace(/<[^>]*>/g, '');

    // 2. Remove the file:/// prefix if present
    stripped = stripped.replace(/^file:\/\/\//, '');

    // 3. Decode HTML entities (&#39; -> ')
    //    Using a <textarea> trick:
    const txt = document.createElement('textarea');
    txt.innerHTML = stripped;
    stripped = txt.value;

    return stripped;
  }
}
